import { GoogleTagManager } from '@iwoca/frontend-tracking-library';
import _ from 'lodash';

import { updateStepData } from '../../actions';

export default (schema) =>
    (values, dispatch, { form }) =>
        new Promise((resolve, reject) => {
            // This is an internal that is used here to determine the field
            // Due to the old redux-form version, it aims to achieve the same
            // as the new API: https://redux-form.com/8.2.2/docs/api/reduxform.md/#-code-asyncvalidate-values-object-dispatch-function-props-object-blurredfield-string-gt-promise-lt-undefined-errors-object-gt-code-optional-
            const fieldIdentifier = _.get(form, '_asyncValidating');
            const fieldName = _.replace(fieldIdentifier, 'company.', '');

            const companyValues = values.company;

            schema
                .validate(
                    {
                        ...companyValues
                    },
                    {
                        abortEarly: false
                    }
                )
                .then(() => {
                    const step = {
                        id: 'businessIntroduction',
                        valid: true
                    };
                    dispatch && dispatch(updateStepData(step));
                    GoogleTagManager.trackFormField({
                        formName: step.id,
                        fieldName,
                        interaction: 'Change'
                    });
                    resolve();
                })
                .catch((errors) => {
                    const step = {
                        id: 'businessIntroduction',
                        valid: false
                    };
                    let formErrors = {
                        company: _.reduce(
                            errors.inner,
                            (memo, err) =>
                                _.setWith(memo, err.path, err.message),
                            {}
                        )
                    };
                    dispatch && dispatch(updateStepData(step));
                    GoogleTagManager.trackFormField({
                        formName: step.id,
                        fieldName,
                        interaction: 'Error'
                    });

                    reject(formErrors);
                });
        });
